// src/components/FloorPlanGenerator/index.js
import React, { useState } from 'react';
import Toolbar from './Toolbar';
import DrawingArea from './DrawingArea';
import TownshipPlanner3D from '../3D/TownshipPlanner3D';
import Instructions from './Instructions';
import AIModal from './AIModal';
import EcoScoreBoard from '../EcoBoard/EcoScoreBoard';
import { useElementManagement } from '../../hooks/useElementManagement';
import './FloorPlanGenerator.css';

const FloorPlanGenerator = () => {
  const [showAIModal, setShowAIModal] = useState(false);
  const [plotSize, setPlotSize] = useState({ width: 1000, height: 800 });
  const [is3DView, setIs3DView] = useState(false);
  
  const {
    elements,
    currentType,
    setCurrentType,
    handleRotate,
    handleDelete,
    handleSave,
    handleClear,
    handleElementCreate,
    handleElementUpdate,
    setElements
  } = useElementManagement();

  const handleAIGenerated = (newElements, requirements) => {
    if (requirements?.plotSize) {
      setPlotSize({
        width: requirements.plotSize.width,
        height: requirements.plotSize.height
      });
    }
    const processedElements = newElements.map(element => ({
      id: Date.now() + Math.random(),
      ...element
    }));
    setElements(processedElements);
  };

  console.log("Current elements:", elements); // Debug log

  return (
    <div className="floor-plan-container">
      {/* Add EcoScoreBoard immediately after the view toggle */}
      <div className="view-toggle">
        <label className="switch">
          <input
            type="checkbox"
            checked={is3DView}
            onChange={(e) => setIs3DView(e.target.checked)}
          />
          <span className="slider round"></span>
          <span className="toggle-label">{is3DView ? '3D View' : '2D View'}</span>
        </label>
      </div>

      {/* Place EcoScoreBoard here with a distinct background */}
      <div style={{ 
        background: '#f0f0f0', 
        padding: '10px', 
        margin: '10px 0',
        border: '2px solid #ddd'
      }}>
        <EcoScoreBoard elements={elements} />
      </div>

      <Toolbar 
        currentType={currentType}
        setCurrentType={setCurrentType}
        onSave={handleSave}
        onClear={handleClear}
        onAIGenerate={() => setShowAIModal(true)}
      />

      {is3DView ? (
        <TownshipPlanner3D 
          elements={elements}
          plotSize={plotSize}
        />
      ) : (
        <DrawingArea
          elements={elements}
          currentType={currentType}
          onElementCreate={handleElementCreate}
          onElementUpdate={handleElementUpdate}
          onRotate={handleRotate}
          onDelete={handleDelete}
          plotSize={plotSize}
        />
      )}

      {showAIModal && (
        <AIModal
          onClose={() => setShowAIModal(false)}
          onGenerate={handleAIGenerated}
          initialPlotSize={plotSize}
        />
      )}

      <Instructions />
    </div>
  );
};

export default FloorPlanGenerator;